import React from 'react'
import moment from 'moment'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

export function getColumnasRechazosAdministrativos (rol) {
  return (
    [
      {
        name: 'cartaDePorteAutomotor',
        label: 'Carta de porte',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (numero) => {
            return (
              <>
                {numero
                  ? <TableValueAction
                    value={numero}
                    title=' '
                    content={<InfoCpa cpa={numero} />} />
                  : null
                }
              </>
            )
          }
        }
      },
      {
        name: 'cereal',
        label: 'Cereal',
        options: {
          filter: true,
          sort: true,
          filterType: 'checkbox'
        }
      },
      {
        name: 'fechaDeCalado',
        label: 'Fecha de calado',
        options: {
          filter: true,
          sort: true,
          filterType: 'multiselect',
          customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM-YY HH:mm')}</> : null
        }
      },
      {
        name: 'exportador',
        label: 'Exportador',
        options: {
          filter: true,
          sort: true,
          filterType: 'multiselect'
        }
      },
      {
        name: 'titularDeCupo',
        label: 'Titular de cupo',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'camion',
        label: 'Camión',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'vendedor',
        label: 'Entregador',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'calificacionCereal',
        label: 'Calificación Cereal',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'humedad',
        label: 'Humedad',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'puestoDeCalado',
        label: 'Puesto Calado',
        options: {
          filter: true,
          filterType: 'checkbox',
          sort: true
        }
      },
      {
        name: 'calleDeCalado',
        label: 'Calle Calado',
        options: {
          filter: true,
          sort: true
        }
      }
    ]
  )
}

export const COLUMNS_RECHAZOS_ADMINISTATIVOS_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 110,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeCalado',
    label: 'Fecha de calado',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificacion Cereal',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'humedad',
    label: 'Humedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'rechazoAdministrativoCalado',
    label: 'Rechazo Administrativo',
    width: 60,
    mantenerCase: true
  }
]
